import React, { useMemo } from 'react';

import BaseRequestsTable from './BaseRequestsTable';
import { getDefaultRequestsColumns } from './columns/defaultRequestsColumns';
import { useAuthStore } from '../../stores/auth.store';

type Props = {
    readonly dateRange?: readonly [Date | null, Date | null];
    readonly userId?: string | null;
    readonly showDateRangeSelector?: boolean;
};

function RequestsTable({
    dateRange,
    userId,
    showDateRangeSelector = true,
}: Props) {
    const { standInForUserIds } = useAuthStore();

    const userIds = useMemo(() => {
        if (userId == null) {
            return null;
        }
        return [userId, ...standInForUserIds];
    }, [userId, standInForUserIds]);

    return (
        <BaseRequestsTable
            dateRange={dateRange}
            userIds={userIds}
            onlyPendingResponsibleActions={false}
            showDateRangeSelector={showDateRangeSelector}
            buildColumns={getDefaultRequestsColumns}
        />
    );
}

export default RequestsTable;
